import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpUtilsService } from '../_base/crud';
import { environment } from '../../../environments/environment';
import { select, Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { currentAuthToken, currentUser } from '../auth';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private authToken;
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  saveAccountMethod(form) {
    const url = `${environment.PAYMENT_MANAGEMENT_BASE}/companies/${this.companyId}/payment_methods`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post(url, form, { headers });
  }

  loadPaymentMethod(contactId: number) {
    const url = `${environment.PAYMENT_MANAGEMENT_BASE}/companies/${this.companyId}/payment_methods/${contactId}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get(url, { headers });
  }

  createTransaction(data: any) {
    const url = `${environment.PAYMENT_MANAGEMENT_BASE}/companies/${this.companyId}/payment_methods/charge`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post(url, data, { headers });
  }

  deactivatePaymentMethod(paymentMethodId: number) {
    const url = `${environment.PAYMENT_MANAGEMENT_BASE}/companies/${this.companyId}/payment_methods/deactivate/${paymentMethodId}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete(url, { headers });
  }
}
